import { NAME_PRODUCTS, NAME_BRAND_ASSETS, NAME_COMPENSATION, NAME_CONTENT_AGREEMENT, NAME_NETWORKS, NAME_SHIPPING_INFO, NAME_PERSONAL_INFO, NAME_TASKS, NAME_UPLOAD_FILES } from './activation-brief-steps';
const ActivationBriefStepRoutes = {
    [NAME_COMPENSATION]: 'v2.activation.brief.payments',
    [NAME_PRODUCTS]: 'v2.activation.brief.products',
    [NAME_PERSONAL_INFO]: 'v2.activation.brief.personalInfo',
    [NAME_TASKS]: 'v2.activation.brief.tasks',
    [NAME_UPLOAD_FILES]: 'v2.activation.brief.uploads',
    [NAME_NETWORKS]: 'v2.activation.brief.networks',
    [NAME_SHIPPING_INFO]: 'v2.activation.brief.shipping',
    [NAME_BRAND_ASSETS]: 'v2.activation.brief.assets',
    [NAME_CONTENT_AGREEMENT]: 'v2.activation.brief.agreements'
};
export default ActivationBriefStepRoutes;
